import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(SplitText);

// console.log("GSAP loaded");

if (window.innerWidth > 768) {
  const smoother = ScrollSmoother.create({
    smooth: 1.5, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").slice(1);
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        e.preventDefault(); // verhindert URL-Änderung
        // targetEl.scrollIntoView({});
        smoother.scrollTo(targetEl, true);
      }
    });
  });

  gsap.to(".sticky-top", {
    scrollTrigger: {
      trigger: ".sticky-top",
      start: "top 50 top",
      end: "+=500",
      scrub: true,
      pin: true,
      pinType: "transform",
      onEnter() {
        // You can use this callback to execute a method when the start point is passed
      },
    },
    ease: "none",
  });

  gsap.to(".animate-scroll", {
    scrollTrigger: {
      trigger: ".animate-scroll",
      start: "0", // Wenn die Box die Mitte erreicht
      end: "bottom top", // Wenn die Box den oberen Rand erreicht
      scrub: true, // Smoothes Scroll-Verhalten
    },
    y: -100, // nach oben schieben
    opacity: 0, // ausblenden
    ease: "none",
  });
  gsap.to(".animate-scroll-delay", {
    scrollTrigger: {
      trigger: ".animate-scroll-delay",
      start: "200", // Wenn die Box die Mitte erreicht
      end: "bottom top", // Wenn die Box den oberen Rand erreicht
      scrub: true, // Smoothes Scroll-Verhalten
    },
    y: -100, // nach oben schieben
    opacity: 0, // ausblenden
    ease: "none",
  });
  gsap.to(".scale-image img", {
    scrollTrigger: {
      trigger: ".scale-image",
      start: "200", // Wenn die Box die Mitte erreicht
      end: "bottom top", // Wenn die Box den oberen Rand erreicht
      scrub: true, // Smoothes Scroll-Verhalten
    },
    scale: 1.3, // nach oben schieben
    ease: "none",
  });
}
